import React, { useCallback, useRef, useState } from 'react';
import {useQuoteState} from "./quoteState"
import {MiniQuote} from "./quoteMiniCart";

import {QuotePrimaryIcon, QuoteSecondaryIcon} from "../../utils/icons";



export const QuoteCount = () => {
  const { items, totalQuantity, totalPrice, showMiniQuote, setShowMiniQuote } = useQuoteState();
  const [ isToggledInside, setIsToggledInside ] = useState(false);

  const quoteLinkRef = useRef(null);



  const toggleMiniQuote = useCallback((e) => {
    e?.preventDefault?.();
    setShowMiniQuote((prev) => !prev);
  }, [setShowMiniQuote]);

  const handleQuoteClick = useCallback((e) => {
    setIsToggledInside(true);
    toggleMiniQuote(e);
  }, [toggleMiniQuote]);

  const handleCloseMiniQuote = useCallback(() => {
    setShowMiniQuote(false);
  }, [setShowMiniQuote]);
  
  return (
    <>
      <a className="header__action-item-link header__quote-toggle" 
         href="/pages/request-a-quote" 
         onClick={handleQuoteClick}
        //  aria-controls="quote-cart"
         aria-expanded={showMiniQuote} 
         data-action="toggle-mini-quote"
         ref={quoteLinkRef} 
        //  tabindex="0"
      >
        <div className="header__action-item-content">
          <div className="header__quote-icon icon-state">
            <span className="icon-state__primary">
              <QuotePrimaryIcon></QuotePrimaryIcon>
              <span className={totalQuantity >= 1 ? 'header__quote-count-new' : 'header__quote-count-new' }>{totalQuantity}</span>
            </span>

            { totalQuantity >= 1 ? <QuoteSecondaryIcon></QuoteSecondaryIcon> : '' }
            {/* <span className="icon-state__secondary">
              <svg focusable="false" className="icon icon--close" viewBox="0 0 19 19" role="presentation"><path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fillRule="evenodd"></path></svg>
            </span> */}
            
          </div>
          <span className="hidden-pocket hidden-lap">Quote</span>
        </div>
      </a>
      {totalQuantity >= 1 ? 
        // <FocusTrap></FocusTrap>
        <MiniQuote isOpen={showMiniQuote} onClose={handleCloseMiniQuote} toggleMiniQuote={toggleMiniQuote} quoteLinkRef={quoteLinkRef} totalPrice={totalPrice} items={items} ></MiniQuote>
        
        : "" }
      
    </>
  );
};



